import { useEffect, useState } from 'react';
import { Button, Image, Table, Form, Modal, Pagination, Divider } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { buildOptionsFromDict, buildOptionsFromStrings } from '../../utils/buildOptionsFromArray';
import { defaultImages, GowIdToCityNameMap } from '../../constants';

const SearchPostsDetailModal = ({
  query,
  newsItems,
  getNewsItems,
  handleSelection,
  setNewsItemQuery,
  resultsPageCount,
  contentType,
  trigger,
  siteId,
}) => {
  const [results, setResults] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [open, setOpen] = useState(false);
  const [original, setOriginal] = useState({
    limit: 10,
    offset: 0,
    site: GowIdToCityNameMap[siteId],
    status: 0,
    start_date: 'Last 7 Days',
    end_date: 'Last 7 Days',
    author_id: '',
    q: '',
    type: contentType,
    time: 'Last 7 Days',
    section: '',
    sort: { field: 'created_ts', direction: 'DESC' },
  });

  const isEvent = () => contentType?.toLowerCase() === 'event';

  useEffect(() => {
    setNewsItemQuery({
      ...original,
      site: GowIdToCityNameMap[siteId],
      sort: { field: 'created_ts', direction: 'DESC' },
    });
  }, [open]);

  useEffect(() => {
    if (!open) return;
    setNewsItemQuery({
      ...original,
      site: GowIdToCityNameMap[siteId],
      sort: { field: 'created_ts', direction: 'DESC' },
    });
    getNewsItems({
      ...original,
      type: contentType,
      site: GowIdToCityNameMap[siteId],
      sort: { field: 'created_ts', direction: 'DESC' },
    });
    setOriginal({
      ...original,
      type: contentType,
      site: GowIdToCityNameMap[siteId],
      sort: { field: 'created_ts', direction: 'DESC' },
    });
  }, [open]);

  useEffect(() => setResults(newsItems), [newsItems]);

  const dates = ['Today', 'Last 7 Days', 'Last 30 Days', 'This Year', 'All Time'];
  const sections = [
    '',
    'Restaurants + Bars',
    'City Life',
    'Entertainment',
    'Travel',
    'Real Estate',
    'Arts',
    'Society',
    'Home + Design',
    'Fashion + Beauty',
    'Innovation',
    'Sports',
  ];
  const dateOptions = buildOptionsFromStrings(dates);
  const sectionOptions = buildOptionsFromStrings(sections);

  const handlePageChange = ({ activePage }, formik) => {
    setActivePage(activePage);
    const offset = 10 * (activePage - 1);
    formik.setFieldValue('offset', offset);
    formik.handleSubmit();
  };

  const handleSubmit = async currentQuery => {
    let subpage_id;
    const { future, ...current } = currentQuery;
    if (future) {
      getNewsItems({
        ...current,
        future,
        type: contentType,
        subpage_id,
        sort: { field: 'created_ts', direction: 'DESC' },
      });
    } else {
      getNewsItems({ ...current, type: contentType, subpage_id, sort: { field: 'created_ts', direction: 'DESC' } });
    }
    setNewsItemQuery({ ...current, future, type: contentType, subpage_id });
  };

  const status = {
    All: '0,1,2,5',
    Live: 0,
    Draft: 5,
    Deleted: 4,
  };

  const stages = buildOptionsFromDict(status).filter(s => s.text !== 'Deleted');

  return (
    <Modal
      size="large"
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={trigger || <Button icon="plus" labelPosition="left" content="Add item" />}
      closeIcon={true}
    >
      <Modal.Header content="Select an item" />
      <Modal.Content style={{ maxHeight: '85vh', padding: 10 }} scrolling>
        <Modal.Description style={{ maxHeight: '82vh' }}>
          <Formik initialValues={query} enableReinitialize onSubmit={handleSubmit}>
            {formik => (
              <div style={{ height: '80vh' }}>
                <Form size="tiny" inline="true">
                  <Form.Group widths={'equal'}>
                    <Form.Field>
                      <label>Headline</label>
                      <Form.Input
                        icon="search"
                        name="q"
                        formik={formik}
                        value={formik.values.q}
                        onChange={(e, { value }) => formik.setFieldValue('q', value)}
                      />
                    </Form.Field>

                    <Form.Field>
                      <strong>Status</strong>
                      <Form.Dropdown
                        selection
                        name="status"
                        style={{ marginTop: 3, width: 200 }}
                        value={formik.values.status}
                        onChange={(e, { value }) => {
                          formik.setFieldValue('status', value);
                          formik.setFieldValue('offset', 0);
                          setActivePage(1);
                          formik.handleSubmit();
                        }}
                        fluid
                        clearable
                        search
                        options={stages || []}
                      />
                    </Form.Field>

                    {[0, 1, 2, 4, 5].includes(formik.values.status) && (
                      <>
                        <Form.Field>
                          <label>Search</label>
                          <Form.Radio
                            name="future"
                            checked={formik.values.future}
                            toggle
                            onChange={(e, { checked }) => {
                              formik.setFieldValue('future', checked);
                              formik.setFieldValue('offset', 0);
                              formik.handleSubmit();
                            }}
                          />
                        </Form.Field>
                      </>
                    )}

                    <Form.Field>
                      <label>Section</label>
                      <Form.Dropdown
                        selection
                        name="section"
                        clearable
                        className="time-dropdown"
                        value={formik.values.section}
                        onChange={(e, { value }) => {
                          formik.setFieldValue('section', value);
                          formik.setFieldValue('offset', 0);
                          formik.handleSubmit();
                        }}
                        fluid
                        search
                        options={sectionOptions || []}
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Publication Date</label>
                      <Form.Dropdown
                        selection
                        name="time"
                        clearable
                        className="time-dropdown"
                        value={formik.values.time}
                        onChange={(e, { value }) => {
                          formik.setFieldValue('time', value);
                          formik.setFieldValue('start_date', value);
                          formik.setFieldValue('end_date', value);
                          formik.handleSubmit();
                        }}
                        fluid
                        search
                        options={dateOptions || []}
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Promoted</label>
                      <Form.Radio
                        checked={formik.values.showPromoted}
                        toggle
                        style={{ paddingTop: 5 }}
                        name="showPromoted"
                        onChange={(e, { checked }) => {
                          formik.setFieldValue('showPromoted', checked);
                          formik.setFieldValue('offset', 0);
                          formik.handleSubmit();
                        }}
                      />
                    </Form.Field>

                    <div style={{ paddingTop: 20, marginRight: 10 }}>
                      <Button
                        type="submit"
                        content="Search"
                        positive
                        size="tiny"
                        fluid
                        onClick={() => handlePageChange({ activePage: 1 }, formik)}
                      />
                    </div>

                    <div style={{ paddingTop: 20 }}>
                      <Button
                        content="Clear"
                        fluid
                        size="tiny"
                        onClick={() => {
                          setNewsItemQuery({ ...original });
                          formik.resetForm();
                          Object.keys(original).forEach(key => {
                            formik.setFieldValue(key, original[key]);
                          });
                          formik.handleSubmit();
                        }}
                      />
                    </div>
                  </Form.Group>
                </Form>
                <Divider />
                <div className="content-results" style={{ fontSize: '.9rem' }}>
                  <Table basic="very" collapsing selectable size="small" padded={false} compact="very">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Photo</Table.HeaderCell>
                        <Table.HeaderCell>Headline</Table.HeaderCell>
                        <Table.HeaderCell width={2}>{isEvent() ? 'Occurrences' : 'Publish Date'}</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Author</Table.HeaderCell>
                        <Table.HeaderCell width={1}>City</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Sections</Table.HeaderCell>

                        <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {results?.map((item, idx) => (
                        <Table.Row key={idx}>
                          <Table.Cell>
                            <Image src={item.image_url || defaultImages.PHOTO_PLACEHOLDER} size="tiny" />
                          </Table.Cell>
                          <Table.Cell>{item.headline}</Table.Cell>
                          <Table.Cell>{item.formatted_date}</Table.Cell>
                          <Table.Cell>{item.author}</Table.Cell>
                          <Table.Cell>{item.city}</Table.Cell>
                          <Table.Cell>{item.status}</Table.Cell>
                          <Table.Cell>
                            {item.sections
                              .map(p => p.name)
                              .map((page, idx) => (
                                <div key={idx} style={{ marginBottom: 5 }}>
                                  {page}
                                </div>
                              ))}
                          </Table.Cell>

                          <Table.Cell collapsing textAlign="center">
                            <Button
                              content="Select"
                              size="tiny"
                              onClick={() => {
                                handleSelection(item);
                                setOpen(false);
                              }}
                            />
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>

                  <div style={{ display: 'grid', justifyContent: 'center' }}>
                    <Pagination
                      size="tiny"
                      totalPages={resultsPageCount}
                      activePage={activePage}
                      onPageChange={(e, data) => handlePageChange(data, formik)}
                    />
                  </div>
                </div>
              </div>
            )}
          </Formik>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = state => ({
  recentPosts: selectors.getRecentPosts(state),
  users: selectors.photos.userOptions(state),
  user: selectors.getUser(state),
  query: selectors.content.query(state),
  authors: selectors.content.authors(state),
  newsItems: selectors.content.newsItems(state),
  count: selectors.content.count(state),
  resultsItemCount: selectors.content.resultsItemCount(state),
  resultsPageCount: selectors.content.resultsPageCount(state),
  sites: selectors.admin.cultureMapSiteOptionsBasic(state),
});

const mapDispatchToProps = dispatch => ({
  getRecentPosts: bindActionCreators(actions.campaign.recentPosts, dispatch),
  getNewsItems: bindActionCreators(actions.content.getNewsItems, dispatch),
  getUsers: bindActionCreators(actions.photos.getUsers, dispatch),
  setNewsItemQuery: bindActionCreators(actions.content.setNewsItemQuery, dispatch),
  setNewsItemPage: bindActionCreators(actions.content.setNewsItemPage, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchPostsDetailModal);
